export default function AgendasDirective() {
  return {
    template: require('./agendas.html'),
    scope: {
      activeAgendas: '=',
      completedAgendas: '=',
    },
    controller: () => { /* 'AgendasController'  */ },
    controllerAs: 'agendasVM',
    bindToController: true,
    replace: true
  };
}
